/* @flow */

import type { Undefined } from '../jsHelpers/types';

import {
  type NETGEM_API_V8_SCHEDULED_RECORDING,
  type NETGEM_API_V8_SCHEDULED_RECORDING_DESCRIPTION_SERIES,
  type NETGEM_SCHEDULED_RECORDINGS_MAP,
  ScheduledRecordingsKind,
} from '../../libs/netgemLibrary/v8/types/Npvr';
import AccurateTimestamp from '../dateTime/AccurateTimestamp';

const isSeriesScheduledRecordingRunning: (seriesScheduledRecording: NETGEM_API_V8_SCHEDULED_RECORDING) => boolean = (seriesScheduledRecording) => {
  if (seriesScheduledRecording) {
    const {
      description,
      description: { kind },
    } = seriesScheduledRecording;

    if (kind === ScheduledRecordingsKind.Series) {
      const { toUtc } = description as Object as NETGEM_API_V8_SCHEDULED_RECORDING_DESCRIPTION_SERIES;

      if (!toUtc || new Date(toUtc) > AccurateTimestamp.nowAsDate()) {
        return true;
      }
    }
  }

  return false;
};

const hasRunningSeriesScheduledRecording: (seriesId: Undefined<string>, npvrScheduledRecordingsList: NETGEM_SCHEDULED_RECORDINGS_MAP) => boolean = (seriesId, npvrScheduledRecordingsList) => {
  if (seriesId) {
    const { [seriesId]: seriesScheduledRecording } = npvrScheduledRecordingsList;
    return isSeriesScheduledRecordingRunning(seriesScheduledRecording);
  }

  return false;
};

export { hasRunningSeriesScheduledRecording, isSeriesScheduledRecordingRunning };
